<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form @submit.prevent="submitDepositForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('budgets.deposit') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body"> 
            <RequiredText />
            <div class="form-group mb-5">
              <label class="form-label fs-6 text-black">{{ $t('financial.accounts.amount') }} <span class="text-danger">*</span></label>
              <VueNumberFormat v-model:value="formData.amount" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
              ></VueNumberFormat>
            </div>
            <div class="form-group mb-3">
              <label class="form-label fs-6 text-black">{{ $t('financial.accounts.reason') }}<span class="text-danger">*</span></label>
              <textarea v-model="formData.reason" class="form-control form-control-solid" rows="3" required></textarea>
            </div>
            <FilesInput v-model="formData.files"/>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoadingDeposit"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>
<script setup>

import {ref, defineProps,  defineEmits} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText";
import VueNumberFormat from 'vue-number-format'
import FilesInput from './FilesInput.vue';
import { useRoute } from 'vue-router';

const emits = defineEmits(['load'])

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        project_id: '',
        amount: 0,
        reason: "",
        files: []
      }
    },
})

const store = useStore()
const route = useRoute()

const formData = ref(props.form)

function closeModal(){
  $('#'+props.id).modal('toggle')
}
const modalId = ref(props.id)

const isLoadingDeposit = ref(false)

function submitDepositForm(){
  isLoadingDeposit.value = true
  store.dispatch('projects/addFundsToBudget', {...formData.value,project_id: route.params.id })
      .then((response) => {
          isLoadingDeposit.value = false
          emits('load')
          closeModal()
          formData.value.amount= 0,
          formData.value.reason= ''
          formData.value.files= []

          window.toastr['success'](i18n.global.t('notification.deposit_created_successfully'))
      })
      .catch(err => {
          isLoadingDeposit.value = false
      })
}
</script>